import { Component, Prop, Vue, Watch } from 'nuxt-property-decorator';

import Button from '../button';
import Tag from '../tag';
import DateElement from '../dateElement';
import TimezoneDeltaTooltip from '../timezoneDeltaTooltip/index.vue';
import IconArrow from '../../assets/svg/arrow-right.svg';
import IconX from '../../assets/svg/x.svg';
import IconCheck from '../../assets/svg/check.svg';
import IconPin from '../../assets/svg/map-pin.svg';
import IconClock from '../../assets/svg/clock.svg';
import IconRocket from '../../assets/svg/rocket.svg';

@Component<MissionCard>({
  components: {
    Button,
    Tag,
    DateElement,
    TimezoneDeltaTooltip,
    IconArrow,
    IconX,
    IconCheck,
    IconPin,
    IconClock,
    IconRocket
  },

  data() {
    return {
      IconArrow,
      IconCheck,
      time: 0,
      IconX,
    };
  },
  created() {
    if (this.mission.selected_at) {
      let now:any = new Date();
      let selected_at = this.mission.selected_at.valueOf();
      let expires_at:any = new Date(selected_at + (15 * 60 * 1000));
      this.$data.time = Math.round((expires_at.getTime() - now.getTime())/ 1000);
    }
  }
})
export default class MissionCard extends Vue {
  @Prop({type: Boolean, default: false})
  dashboard!: boolean;

  @Prop()
  mission!: {
    id: string;
    category: {
      color: string;
      icon: any;
    };
    title: string;
    date: {
      dayString: string;
      dayNumber: string;
      hour: string;
      info: any;
    };
    tags: [{
      label: string;
      color?: string;
    }];
    desc: string;
    price: string;
    location: string;
    schedule: string;
    selected_at: any;
    organization: any;
  };

  @Prop({type: Boolean, default: false})
  inCart!: boolean;

  @Prop({type: Boolean, default: false})
  noAction!: boolean;

  @Prop({type: Boolean, default: false})
  addButtonDisabled!: boolean;

  @Prop({ type:Boolean, default: false })
  bonus!: boolean;

  @Prop({ type:String, default: '' })
  bonusAlert!: string;

  @Prop({ type:Boolean, default: false })
  atHome!: boolean;

  @Watch('time')
  onTimeChange(value: number) {
    // @ts-ignore
    window.eventBus.$emit('syncTimer', this.decreaseTime)
  }

  decreaseTime() {
    this.$data.time -= 1;
    if (this.$data.time === 0) {
      this.$emit('time-over', this.mission.id);
    }
  }

  showTime(time: number) {
    return  (time - ( time %= 60 ) ) / 60 + ( 9 < time ? ':' : ':0' ) + time;
  }
}
